import { createContext } from 'react';

const BookLocationInitialValuesContext = createContext({
  initialBookLocation: null,
});

export default BookLocationInitialValuesContext;
